//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mixins from '@/configs/mixins';
import hum from 'humanize-duration';


export default {
    name: 'HallList',
    mixins: [mixins],
    props: {
        datas: Array,
        listType: {
            type: String,
            default: 'tender'
        },
    },
    data() {
        return {
            nowDate: new Date(),

        }
    },
    computed: {
        allDic() {
            return this.$store.state.allDic;
        },
    },
    methods: {
        itemClick(item) {
            this.$emit('item-click', item);
        },
        goodsType(type) {
            let goodsType = '--';
            if (this.allDic['goodsType']) {
                this.allDic['goodsType'].children.map((item) => {
                    if (`${type}` === item.id) {
                        goodsType = item.value;
                    }
                    return item;
                })
            }
            return goodsType;
        },
        pastTime(time = '') {
            let diff = 0;
            const end = new Date(time.replace(/-/g, '/'));
            diff = end.getTime() - this.nowDate.getTime();
            if (diff <= 0) {
                return false;
            } else if (diff > 0) {
                return true;
            }
        },
        leftTime(time = '') {
            let diff = '';
            const end = new Date(time.replace(/-/g, '/'));
            diff = Math.floor((end.getTime() - this.nowDate.getTime()) / 1000);
            return this.getLeveTime(diff);
        },
        getLeveTime(r) {
            let t = '';
            if (r - 0 === 0) {
                return 0;
            }
            if (r) {
                t = hum(r * 1000, {
                    language: 'zh_CN',
                    delimiter: ' ',
                    largest: 1,
                }).replace(/\s/g, '');
            }
            return t;
        },
    },
};
